class Route {
    title
    path
    isRequiredAuth
    category
    isMenu
    menuIndex = 1
    menuBadge
    parentRouteId

    constructor(parentRouteId) {
        this.parentRouteId = parentRouteId
    }

    static getRules(context) {
        const parentRouteIdValidator = (rule, value, callback) => {
            if (context !== undefined && context !== null && value === context.route.id) {
                callback(new Error("无法选择自己作为父路由"))
            } else {
                callback()
            }
        }

        return {
            title: [
                {required: true, trigger: "blur", message: "请输入路由标题"},
            ],
            parentRouteId: [
                {required: true, trigger: "blur", message: "请选择父路由"},
                {validator: parentRouteIdValidator, trigger: "blur"}
            ],
            path: [
                {required: true, trigger: "blur", message: "请输入路由路径"}
            ]
        }
    }
}

export default Route